import { ReactNode, useState, MouseEvent as ReactMouseEvent } from "react"

import { css, cx } from "@emotion/css"

import Button from "ui/buttons/Button"
import CloseIcon from "@material-ui/icons/Close"
import { ReactComponent as FilterIcon } from "assets/filters.svg"
import IconButton from "ui/buttons/IconButton"
import Popover from "@material-ui/core/Popover"
import { useI18n } from "providers/I18n"

const styles = {
  container: css`
    padding: var(--spacing-xxl-2);
    width: 100%;
    min-height: calc(3.3 * 128px + 2 * 1rem);
    min-width: calc(3 * 128px + 2 * 1rem);
  `,
  titleBar: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--spacing-xxl-2);
  `,

  filterls: css`
    display: flex;
    overflow-y: auto;

    & > :not(:first-child) {
      margin-left: var(--spacing-xl);
    }
  `,
  btnLabel: css`
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.6;
    text-transform: capitalize;
  `,

  resetBtn: css`
    margin-left: auto;
    margin-right: var(--spacing-xs);
  `,
  popover: css`
    max-height: calc(100% - 20.5rem);
    margin-top: var(--spacing-s);
  `,
}

export type FilterProps = {
  containerHeight?: string
  children: ReactNode
  onReset: () => void
  count?: number
  title?: string
}

export function Filters(props: FilterProps) {
  const { children, onReset, count, title } = props
  const { t } = useI18n()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const onOpen = (event: ReactMouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const onClose = () => setAnchorEl(null)
  const open = Boolean(anchorEl)

  return (
    <div>
      <Button
        onClick={onOpen}
        weight="normal"
        startIcon={<FilterIcon />}
        className={cx({ active: open })}
      >
        <span className={styles.btnLabel}>{t("filters.plan.lines.label")}</span>
        {!!count ? <span> ({count})</span> : null}
      </Button>
      <Popover
        open={open}
        onClose={onClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        classes={{ paper: styles.popover }}
      >
        <div className={styles.container}>
          <div className={styles.titleBar}>
            <span className="BodyBody-1BlackBold">
              {title || t("table.campaigns.filters.title")}
              {!!count ? <span> ({count})</span> : null}
            </span>
            {!!count ? (
              <Button
                color="primary"
                onClick={onReset}
                className={styles.resetBtn}
              >
                {t("table.filters.reset")}
              </Button>
            ) : null}
            <IconButton aria-label="close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={styles.filterls}>{children}</div>
        </div>
      </Popover>
    </div>
  )
}
